const dataUnderval = [
  { investorType: 'Mutual FUnd', overvaluationReason: 'Leverage', count : 5 },
  { investorType: 'Hedge Fund', overvaluationReason: 'Leverage', count : 2 },
  { investorType: 'Institutionnal', overvaluationReason: 'Leverage', count : 10 },
  { investorType: 'type4', overvaluationReason: 'Leverage', count : 4 },
  { investorType: 'type5', overvaluationReason: 'Leverage', count : 4 },
  
  { investorType: 'Mutual FUnd', overvaluationReason: 'Cost Inflation', count : 3 },
  { investorType: 'Hedge Fund', overvaluationReason: 'Cost Inflation', count : 1 },
  { investorType: 'Institutionnal', overvaluationReason: 'Cost Inflation', count : 6 },
  { investorType: 'type4', overvaluationReason: 'Cost Inflation', count : 4 },
  { investorType: 'type5', overvaluationReason: 'Cost Inflation', count : 3 },
  
];

export default dataUnderval;
